import { isAuthenticated } from 'helpers/JwtTokenUtil'

export default (initialState = {}) => {
  let newState = {
    user: {
      authenticated: isAuthenticated()
    }
  }
  return newState
}
